import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetProjectChecklistsInput, ProjectChecklistInput, ProjectChecklistResult, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ProjectChecklistService {

  constructor(private httpClient: HttpClient) { }

  public addProjectChecklist(projectChecklistInput: ProjectChecklistInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'ProjectChecklist/AddProjectChecklist', projectChecklistInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editProjectChecklist(id: number, projectChecklistInput: ProjectChecklistInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'ProjectChecklist/EditProjectChecklist?id=' + id, projectChecklistInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteProjectChecklist(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'ProjectChecklist/DeleteProjectChecklist?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getProjectChecklists(getProjectChecklistsInput: GetProjectChecklistsInput): Promise<ResultList<ProjectChecklistResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'ProjectChecklist/GetProjectChecklists', getProjectChecklistsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ProjectChecklistResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ProjectChecklistResult>(), result.error));
  }
}